module.exports = __webpack_public_path__ + "static/media/auth-layer.2686db28.png";